import { Observable } from 'rxjs'
import { RpsSource, SourceFieldCatalog } from '../models/field-catalog.model'

/**
 * Seam between the workbench and the Flex Positions field-catalog API, mirroring the
 * {@link WorkbenchDataSource} seam. The panel binds {@link HttpFieldCatalogService}, which hits the
 * real backend — there is no fabricated catalog anywhere in the running panel.
 *
 * One catalog is fetched per grid (per source), never one combined `sources=` call, so a 404 on
 * the Enfusion catalog does not starve the Prometheus grid. An empty catalog (CW: 0 columns / no
 * groups) is legitimate, not an error.
 */
export abstract class FieldCatalogService {
  /**
   * Fetch the field catalog for one source under one account. Implementations cache on
   * (accountId, source); PROMETHEUS is static and may be cached on source alone. An account switch
   * must invalidate the account-specific (Enfusion) catalog — nothing is cached across accounts.
   */
  abstract getCatalog(
    accountId: number,
    source: RpsSource,
  ): Observable<SourceFieldCatalog>

  /** Drop every catalog cached for an account (called on account switch). */
  abstract invalidate(accountId: number): void
}
